import useKeyboardShortcut from '../../../hooks/useKeyboardShortcut';
import { useQuickMenuContext } from './QuickMenuContext';

const useQuickMenu = () => {
  const { quickMenu, setQuickMenu } = useQuickMenuContext();

  const closeQuickMenu = () => setQuickMenu(undefined);
  const openQuickMenu = () => setQuickMenu({ useAi: false });

  const toggleQuickMenu = (e: KeyboardEvent) => {
    if (e.shiftKey) {
      setQuickMenu({ useAi: true });
    } else {
      setQuickMenu({ useAi: false });
    }

    if (quickMenu) {
      closeQuickMenu();
      return;
    }
  };

  useKeyboardShortcut(toggleQuickMenu, {
    code: 'KeyK',
    metaKey: true,
  });

  useKeyboardShortcut(toggleQuickMenu, {
    code: 'KeyK',
    ctrlKey: true,
    preventDefault: true,
  });

  return { quickMenu, openQuickMenu, closeQuickMenu, setQuickMenu };
};

export default useQuickMenu;
